import { useState, useEffect } from 'react';
import { useFamilyStore } from '../stores/familyStore';

interface ChildrenNameMap {
  [childId: string]: string;
}

/**
 * Hook do pobierania nazw dzieci na podstawie ich ID
 * Używa danych z familyStore, więc nie wymaga dodatkowych zapytań do bazy
 */
export function useChildrenNames() {
  const { children } = useFamilyStore();
  const [childrenNames, setChildrenNames] = useState<ChildrenNameMap>({});

  useEffect(() => {
    if (!children || children.length === 0) return;

    const namesMap: ChildrenNameMap = {};
    children.forEach(child => {
      namesMap[child.id] = child.name;
    });

    setChildrenNames(namesMap);
  }, [children]);

  /**
   * Pobiera nazwę dziecka na podstawie ID
   * @param childId ID dziecka
   * @returns Nazwa dziecka lub 'dziecka' jeśli nie znaleziono
   */
  const getChildName = (childId?: string): string => {
    if (!childId) return 'dziecka';
    return childrenNames[childId] || 'dziecka';
  };

  return {
    childrenNames,
    getChildName,
    isLoaded: Object.keys(childrenNames).length > 0
  };
}